import { baseCommand } from "./basecommand";

type deleteItemTypename = "item_delete";
type deleteItemdatatype = {
    "guid" : string;
}

type pscommand<T> = {
    "type": T extends deleteItemTypename ? T : never;
    "data": T extends deleteItemTypename ? deleteItemdatatype : never;
};

export type deleteItemCommand = pscommand<deleteItemTypename>;

export class deleteItem extends baseCommand {
    private type: deleteItemTypename = "item_delete";

    constructor(public guid: string = "00000000-0000-0000-0000-000000000000") {
        super();
    }

    public object(): deleteItemCommand {
      return {
          "type": this.type,
          "data": {
            "guid" : this.guid
          }
      }
    }
}
